/* eslint-disable react/prop-types */
import classes from "./local-announcements.module.scss";

import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewSix from "@/composed-views/composed-view-six";
import ComposedViewFive from "@/composed-views/composed-view-five";
import ComposedViewSeven from "@/composed-views/composed-view-seven";

function LocalAnnouncements({ content: localAnnouncements }) {
  return (
    <Flex
      align="flex-start"
      className={classes.localAnnouncements}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={localAnnouncements.header.header}
        title={localAnnouncements.header.title}
        subTitle={localAnnouncements.header.subTitle}
      />

      <ComposedViewSix
        header={localAnnouncements.europeanFounds.header}
        title={localAnnouncements.europeanFounds.title}
        columnOne={localAnnouncements.europeanFounds.columnOne}
        columnTwo={localAnnouncements.europeanFounds.columnTwo}
        className={classes.europeanFounds}
      />

      <ComposedViewSix
        header={localAnnouncements.types.header}
        title={localAnnouncements.types.title}
        columnOne={localAnnouncements.types.columnOne}
        columnTwo={localAnnouncements.types.columnTwo}
      />

      <ComposedViewSeven
        title={localAnnouncements.support.title}
        steps={localAnnouncements.support.steps}
      />

      <ComposedViewFive
        title={localAnnouncements.discover.title}
        button={localAnnouncements.discover.button}
        className={classes.discover}
      />
    </Flex>
  );
}

export default LocalAnnouncements;
